import scriptLoader from 'react-async-script-loader';

export default function loadMapScripts(component) {
  return scriptLoader([
    'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyAEuVTDxH5Tn1CXcD5yHMN9FDdcK9mSdqg'
  ])(component);
}
